module.exports = __webpack_public_path__ + "static/iep-b7bf215beb6e63b0ae3f9539e8f935bc.png";